import { DataGrid } from "@msuite/ui/data-grid";
import { useTranslation } from "@msuite/ui/localization";
import type { Row } from "@msuite/ui/table";
import type { Tables } from "@msuite/utils/types";

/** Props Interface */
interface CalculationServicesSubrowProps {
	row: Row<Tables<"serviceCalculationItems">>;
}

export function CalculationServicesSubrow({ row }: CalculationServicesSubrowProps) {
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="pr-[50%] p-4">
			<DataGrid variant="border">
				<DataGrid.Row>
					<DataGrid.Label>{t("organization.data.short_text")}</DataGrid.Label>
					<DataGrid.Value>{row.original.shortText}</DataGrid.Value>
				</DataGrid.Row>
				<DataGrid.Row>
					<DataGrid.Label>{t("organization.data.long_text")}</DataGrid.Label>
					<DataGrid.Cell>{row.original.longText}</DataGrid.Cell>
				</DataGrid.Row>
			</DataGrid>
		</div>
	);
}
